import { render, staticRenderFns } from "./constitution.vue?vue&type=template&id=23593f92&scoped=true&"
import script from "./constitution.vue?vue&type=script&lang=js&"
export * from "./constitution.vue?vue&type=script&lang=js&"
import style0 from "./constitution.vue?vue&type=style&index=0&id=23593f92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23593f92",
  null
  
)

export default component.exports